import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-male-calisthenics',
	options: {
		userTags: ['calisthenics'],
	},
	landing: {
		ids: ['loader-calisthenics-m', 'age-calisthenics-m'],
		route: {
			path: '/activity-calisthenics-m',
			name: 'male-activity-calisthenics-funnel',
		},
	},
	funnel: {
		id: 'ob-male-activity-calisthenics',
		route: {
			path: '/activity-calisthenics-m/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'male-activity-calisthenics-onboarding',
		},
		// @ts-expect-error - Legacy: slug не совпадает с appArea, будет исправлено позже
		slug: 'male-activity-calisthenics',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-calisthenics-m',
	},
	upsell: {
		routeNames: ['upsell-calisthenics-m'],
	},
}

export default appAreaConfig
